// Utils
import Yup from "../../../utils/yup";

export default Yup.object().shape({
    customer_address: Yup.string().required("Required"),
    customer_city: Yup.string().required("Required"),
    customer_zipcode: Yup.string().required("Required"),
})